<template>
  <section
    id="code-discount"
    class="service-checkout service-code-discount"
    :class="{ 'order-item-section': isQuotationMode }"
  >
    <span class="section__title">
      優惠與推薦
    </span>
    <div class="section__content">
      <code-discount-input
        ref="codeDiscountInput"
        class="code-discount-input"
        :is-phone-validate="Boolean(guestPurchase.createGuestAccountData) || $auth.loggedIn"
        :can-use-enterprise-coin="canUseEnterpriseCoin"
        :order-amount="totalAmount"
        :service-id="serviceId"
        :service-type-id="serviceTypeId"
        :ticket-amount="discountData.ticket.discount"
        :can-use-bonus-amount="canUseBonusAmount"
        :bonus-amount="bonusAmount"
        :discount-data="discountData"
        @memberLogin="$emit('memberLogin')"
        @updateDiscountUsage="updateDiscountDataHandler"
      />
      <discount-list
        ref="discountList"
        class="discount-list"
        :service-id="serviceId"
        :service-type-id="serviceTypeId"
        :order-amount="totalAmount"
        :has-promotion="hasPromotion"
        :promotion-discount-amount="promotionDiscountAmount"
        :discount-data="discountData"
        @openSelectTicket="$emit('openSelectTicket')"
        @updateDiscountUsage="updateDiscountDataHandler"
      />
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import CodeDiscountInput from '../../components/Input/CodeDiscountInput.vue'
import DiscountList from '../../components/List/DiscountList.vue'
export default {
  components: {
    CodeDiscountInput,
    DiscountList
  },
  inject: {
    isQuotationMode: {
      from: 'isQuotationMode',
      default: false
    }
  },
  props: {
    canUseEnterpriseCoin: {
      type: Boolean,
      default: false
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    serviceId: {
      type: String | Number,
      default: null
    },
    serviceTypeId: {
      type: String | Number,
      default: null
    },
    discountData: {
      type: Object,
      default: () => {}
    },
    canUseBonusAmount: {
      type: Number,
      default: 0
    },
    bonusAmount: {
      type: Number,
      default: 0
    },
    firebaseValue: {
      type: Object,
      default: () => {
        return {
          canUseTickets: true,
          canUseBonus: true
        }
      }
    },
    hasPromotion: {
      type: Boolean,
      default: false
    },
    promotion: {
      type: Object,
      default: () => {}
    },
    promotionDiscountAmount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(['guestPurchase']),
    discountAmount () {
      return this.discountData.code.discount
    },
    ticketAmount () {
      return this.discountData.ticket.discount
    },
    canUseTicket () {
      return this.firebaseValue.canUseTickets
    },
    canUseBonus () {
      return this.firebaseValue.canUseBonus
    }
  },
  methods: {
    updateDiscountDataHandler ({ type, data, isAutoCheck = false }) {
      const isUpdateTicketAndNotAvaliable = type === 'ticket' && !this.canUseTicket
      const isUpdateBonusAndNotAvaliable = type === 'bonus' && !this.canUseBonus
      if (isUpdateTicketAndNotAvaliable || isUpdateBonusAndNotAvaliable) return
      this.$emit('updateDiscountDataHandler', { type, data })
      const useDiscount = type === 'code' && data.discount > 0
      const excludeCheckBonusType = ['bonus', 'tempInput']
      if (!excludeCheckBonusType.includes(type) && !useDiscount && !isAutoCheck) {
        this.updateCheckHandler('bonus')
      }
    },
    async updateCheckHandler (type, data) {
      switch (type) {
        case 'code':
          await this.$refs.codeDiscountInput.discountCodeConfirmHandler(data.isAutoCheck, data.discountInput)
          break
        case 'ticket':
          await this.$refs.discountList.checkTicketUsageHandler(true, {
            ServiceId: this.serviceId,
            OrderAmount: this.totalAmount - this.discountAmount
          })
          break
        case 'bonus':
          if (this.$auth.loggedIn) {
            await this.$refs.discountList.updateAvaliableBonusHandler(true, {
              ServiceId: this.serviceId,
              OrderAmount: this.totalAmount - this.discountAmount - this.ticketAmount
            })
          } else {
            const availableBonusMaxAmount = this.totalAmount - this.discountAmount - this.ticketAmount
            const usedEnterpriseCoin = this.discountData.bonus?.point?.CanUseEnterpriseAmount || 0
            const originEnterpriseCoin = this.discountData.bonus?.point?.OriginEnterpriseCoinResult || 0
            if (availableBonusMaxAmount < usedEnterpriseCoin) {
              this.discountData.bonus.point.CanUseEnterpriseAmount = availableBonusMaxAmount
            } else if (usedEnterpriseCoin !== originEnterpriseCoin) {
              this.discountData.bonus.point.CanUseEnterpriseAmount = availableBonusMaxAmount > originEnterpriseCoin ? originEnterpriseCoin : availableBonusMaxAmount
            } else return
            this.$emit('updateDiscountDataHandler', {
              type: 'bonus',
              data: {
                ...this.discountData.bonus
              }
            })
          }
          break
      }
    },
    async discountSetHandler () { // 優惠券、折扣碼、紅利點數於預約資訊頁(step3)自動觸發檢查
      const routerSave = this.$auth.$storage.getCookie('routerSave')
      this.$emit('updateDiscountDataHandler', {
        type: 'bonus',
        data: {
          ...this.discountData.bonus,
          isLoading: true
        }
      })
      const isRouterDiscountCheck = routerSave?.discount?.length <= 7 && !this.discountData.tempInput && !this.discountData.code.isUse // 用戶未使用折扣碼 && 未輸入折扣碼 && 有連結帶入折扣碼
      if (this.discountData.code.isUse || isRouterDiscountCheck) { // 用戶已使用折扣碼
        this.discountData.code.isUse = false
        const checkInfo = {
          isAutoCheck: true,
          discountInput: isRouterDiscountCheck ? routerSave.discount : this.discountData.code.input
        }
        await this.updateCheckHandler('code', checkInfo)
      }
      await this.updateCheckHandler('ticket')
      await this.updateCheckHandler('bonus')
      this.$emit('updateDiscountDataHandler', {
        type: 'bonus',
        data: {
          ...this.discountData.bonus,
          isLoading: false
        }
      })
    },
    getDiscountInputCode () {
      return this.$refs.codeDiscountInput.discountCode.input
    }
  }
}
</script>
<style lang="scss" scoped>
.discount-list {
  margin-top: 10px;
}
.order-item-section {
  padding: 14px 10px 15px;
  flex: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-variant-numeric: tabular-nums;
  .section__title {
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
    flex: none;
    display: flex;
    position: relative;
    padding-bottom: 9px;
  }
  .section__content {
    margin-top: 0;
  }
}
/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  .order-item-section {
    padding: 17px 30px 0px;
    border: 1px solid #d2d2d2;
    .section__title {
      text-align: center;
      border-bottom: 1px solid #D2D2D2;
      justify-content: center;
    }
    .section__content {
      margin-top: 24px;
      padding-bottom: 24px;
    }
  }
}
</style>
